import { StatusBadge } from '../../../components/ui/status-badge';
import { ORDER_QUOTE_OFFER_STATUS } from '../../../lib/status-configs';

export function OfferStatusBadge({ status }: { status: string }) {
	const config = ORDER_QUOTE_OFFER_STATUS[status] ?? { label: status, tone: 'neutral' as const };
	return <StatusBadge active activeLabel={config.label} activeTone={config.tone} />;
}
